import usePageMeta from "utils/usePageMeta";
import MKBox from "components/MKBox";

import SubPageLayout from "reusables/layouts/SubPageLayout";

import PlannedMaintenance_Section1 from "./sections/PlannedMaintenance_Section1";

function PlannedMaintenance() {
  usePageMeta({
    title: "Planned Preventive Maintenance Ireland | Spechs",
    description:
      "Planned preventive maintenance for properties across Ireland. Keep your property in top condition year-round.",
    canonical: "https://www.spechs.ie/property/planned-maintenance/",
  });

  return (
    <SubPageLayout title="Planned Preventive Maintenance">
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <PlannedMaintenance_Section1 />
      </MKBox>
    </SubPageLayout>
  );
}

export default PlannedMaintenance;
